export type BlogSection =
  | 'Business'
  | 'Sport'
  | 'Innovation'
  | 'News'
  | 'Leisure'
  | 'Stock Market'
  | 'Gold & Forex Rates'
  | 'Cryptocurrency'
  | 'Top Stories';

export const BLOG_SECTIONS: BlogSection[] = [
  'Business',
  'Sport',
  'Innovation',
  'News',
  'Leisure',
  'Stock Market',
  'Gold & Forex Rates',
  'Cryptocurrency',
  'Top Stories',
];

// Slug mapping for clean URLs
const SLUG_MAP: Record<string, string> = {
  Business: 'business',
  Sport: 'sport',
  Innovation: 'innovation',
  News: 'news',
  Leisure: 'leisure',
  'Stock Market': 'stock-market',
  'Gold & Forex Rates': 'gold-forex-rates',
  Cryptocurrency: 'cryptocurrency',
  'Top Stories': 'top-stories',
};

const REVERSE_SLUG_MAP: Record<string, BlogSection> = Object.fromEntries(
  Object.entries(SLUG_MAP).map(([k, v]) => [v, k as BlogSection])
) as Record<string, BlogSection>;

export function sectionToSlug(section: BlogSection): string {
  return SLUG_MAP[section] || 'business';
}

export function slugToSection(slug: string | undefined | null): BlogSection | null {
  if (!slug) return null;
  const s = String(slug).toLowerCase();
  return REVERSE_SLUG_MAP[s] ?? null;
}

export function isValidSection(value: string | null | undefined): value is BlogSection {
  return BLOG_SECTIONS.includes((value as BlogSection) || '');
}



// Color map for section-specific banner backgrounds
export const SECTION_COLOR_MAP: Record<BlogSection, string> = {
  Business: '#1E40AF',        // Blue
  Sport: '#16A34A',           // Green
  Innovation: '#7C3AED',      // Purple
  News: '#DC2626',            // Red
  Leisure: '#EA580C',         // Orange
  'Stock Market': '#0D9488',  // Teal
  'Gold & Forex Rates': '#1F2937', // Dark gray
  Cryptocurrency: '#8B5CF6',  // Violet
  'Top Stories': '#da1884',   // Brand pink
};
